module.exports = __webpack_public_path__ + "static/media/ella.8d79bdfb.svg";